import React from 'react';
import {QueryClient, QueryClientProvider} from 'react-query';
import {ReactQueryDevtools} from 'react-query/devtools';

import './shared/styles/crema.less';
import {
  AppContextProvider,
  AppLayout,
  AppSuspense,
  AppThemeProvider,
  AuthRoutes,
} from './@crema';
import {AuthContextProvider} from './contexts/AuthContextProvider/authContext';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import './@crema/services/index';
import SidebarContextProvider from 'contexts/AppContextProvider/SidebarContextProvider';
import ModuleTracker from 'components/AppComponents/ModuleTracker';
import ApkDistributionApp from 'pages/ApkDistribution';
import './shared/styles/customdesign.less';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      suspense: true,
    },
  },
});

const MainApp = () => (
  <AuthContextProvider>
    <SidebarContextProvider>
      <AuthRoutes>
        <AppLayout />
      </AuthRoutes>
    </SidebarContextProvider>
  </AuthContextProvider>
);

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <AppSuspense>
        <AppContextProvider>
          <AppThemeProvider>
            <BrowserRouter>
              <ModuleTracker />
              <Routes>
                <Route
                  path='/apk-distribution/*'
                  element={<ApkDistributionApp />}
                />
                <Route path='/*' element={<MainApp />} />
              </Routes>
            </BrowserRouter>
          </AppThemeProvider>
        </AppContextProvider>
      </AppSuspense>
      {process.env.REACT_APP_STAGE && <ReactQueryDevtools />}
    </QueryClientProvider>
  );
};

export default App;
